/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2022-12-26 15:31:12
 * @LastEditors: linxi
 * @LastEditTime: 2023-02-24 09:57:40
 */
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Select,
  Space,
  Upload,
} from 'antd'
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../app/store'
import { getOnlyOrgaztionCompletions } from '../completion/completionSlice'
import styles from './reservationChannel.module.css'
import { getReservationChannelEditSubmit } from './reservationChannelSlice'

interface editDetailModalProps {
  id: any
  visible: boolean
  onCancel: () => void
  onOk: () => void
}
export const EditDetailModal = ({
  id,
  visible,
  onCancel,
  onOk,
}: editDetailModalProps): ReactElement => {
  const [form] = Form.useForm()

  const [loading, setLoading] = useState(false)

  const dispatch = useDispatch<RootDispatch>()

  const [imageUrl, setImageUrl] = useState<any>()

  const [detail, setDetail] = useState<any>()

  const [keyword, setKeyword] = useState('')

  const [tenantOptions, setTenantOptions] = useState<any>()

  useEffect(() => {
    if (visible)
      dispatch(
        getOnlyOrgaztionCompletions({
          name: keyword,
          size: 1000,
          current: 1,
          status: 1,
        })
      )
        .then(unwrapResult)
        .then((page: any) => {
          console.log(page, 'page?.records')
          setTenantOptions(page?.items)
        })
        .catch(() => {
          //
        })
  }, [visible, keyword])

  return (
    <Modal
      title='新增合作机构'
      width={600}
      visible={visible}
      // destroyOnClose
      onCancel={() => {
        onCancel()
        form.resetFields()
      }}
      centered
      footer={null}
      className={styles.editRemark}
      maskStyle={{
        overflow: 'hidden',
      }}
    >
      <Form
        className={styles.form}
        form={form}
        onFinish={(values) => {
          console.log(values, 'values')
          dispatch(
            getReservationChannelEditSubmit({
              ...values,
              status: 0,
            })
          )
            .then(unwrapResult)
            .then((v) => {
              notification.success({
                message: '操作成功',
                duration: 3,
              })
              onOk()
              form.resetFields()
            })
        }}
        labelCol={{
          span: 4,
        }}
        wrapperCol={{
          span: 20,
        }}
      >
        <Form.Item
          label='机构名称'
          name='tenantId'
          rules={[{ required: true, message: '请选择机构名称' }]}
        >
          <Select
            style={{ width: '300px' }}
            showSearch
            placeholder='机构名称'
            defaultActiveFirstOption={false}
            showArrow={false}
            filterOption={false}
            onSearch={(e: any) => {
              console.log(e, '机构名称')
              setKeyword(e)
            }}
          >
            {tenantOptions?.map((el: any) => (
              <Select.Option key={el.id} value={el.id}>
                {el.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name='comment' label='备注'>
          <Input style={{ width: '300px' }} />
        </Form.Item>

        <div
          style={{
            display: 'flex',
            justifyContent: 'end',
            width: '100%',
            paddingTop: '100px',
          }}
        >
          <Space>
            <Button onClick={() => onCancel()}>取消</Button>
            <Button type='primary' htmlType='submit'>
              确定
            </Button>
          </Space>
        </div>
      </Form>
    </Modal>
  )
}
